
































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import BaseModal from './ui/BaseModal.vue'
import CartItem, { ICartItem } from '@/store/models/CartItem'
import DefaultButton from './ui/DefaultButton.vue'
import FrameTile from './ui/FrameTile.vue'
import Frame from '@/data/frame'
@Component({
  components: {
    BaseModal,
    DefaultButton,
    FrameTile
  }
})
export default class FramePopup extends Vue {
  @Prop() private item?: CartItem
  private showModal: boolean = false
  private items: number[] = []
  private get framePrice (): number {
    if (this.item) {
      if (this.item.framePrice) {
        return this.item.framePrice
      }
      return 0
    }
    return 0
  }
  private set framePrice (value: number) {
    if (this.item) {
      this.deselectAll()
      this.item.framePrice = value
    }
  }

  public get displayFramePrice (): string {
    if (this.framePrice) {
      if (this.framePrice > 0) {
        return this.framePrice.toString()
      }
      return ''
    }
    return ''
  }

  public set displayFramePrice (value: string) {
    this.framePrice = parseFloat(value)
  }

  private deselectAll () {
    this.frames.forEach((f: Frame) => {
      f.selected = false
    })
  }

  private get frameSelectionTitle (): string {
    if (this.$store.state.data.optician.frameSelectionTitle) {
      return this.$store.state.data.optician.frameSelectionTitle
    }
    return ''
  }

  private get frameSelectionSubTitle (): string {
    if (this.$store.state.data.optician.frameSelectionSubTitle) {
      return this.$store.state.data.optician.frameSelectionSubTitle
    }
    return ''
  }

  private selectItem (frame: Frame) {
    if (frame && this.item) {
      if (!frame.selected) {
        this.deselectAll()
        frame.selected = true
        this.item.framePrice = frame.price
      } else {
        frame.selected = false
        this.item.framePrice = 0
      }
    }
  }

  private get frames (): Frame[] {
    return this.$store.state.data.optician.frames
  }
  private mounted () {
    for (let i = 0; i < 8; i++) {
      this.items.push(i)
    }
  }
}
